import './css/Menu.css';
import IconEua from '../../assets/iconEua.png';
import IconBrasil from '../../assets/iconBrasil.png';
import { translateMenu } from '../../data/translateMenu';

// 2. Recebemos as props que vieram do App.js
function Menu({ language, setLanguage }) {
    
    // 3. Selecionamos o dicionário correto com base no estado atual ('pt' ou 'en')
    const select = translateMenu[language].menu;

    return (
        <nav className="container-menu">
            <ul className="itens-menu">
                {/* 4. Substituímos os textos fixos pelas variáveis */}
                <li><a href="#about">{select.sobre}</a></li>
                <li><a href="#tech">{select.tecnologias}</a></li>
                <li><a href="#projects">{select.projetos}</a></li>
                <li><a href="#experience">{select.experiencia}</a></li>
                <li><a href="#education">{select.educacao}</a></li>
                <li><a href="#contact">{select.contato}</a></li>
            </ul>
            <ul className="itens-language">
                {/* 5. Adicionamos o evento onClick para mudar a linguagem */}
                <li 
                    className="icon-language" 
                    onClick={() => setLanguage('pt')} 
                    style={{ cursor: 'pointer' }} // Adiciona o dedinho de clique
                >
                    <img src={IconBrasil} alt='Linguagem - PT BR' className='image-bandeira'/>
                </li>
                <li 
                    className="icon-language" 
                    onClick={() => setLanguage('en')} 
                    style={{ cursor: 'pointer' }}
                >
                    <img src={IconEua} alt='Language - English' className='image-bandeira'/>
                </li>
            </ul>
        </nav>
    );
}

export default Menu;